export enum ReleaseType {
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
  PATCH = 'PATCH',
}

export enum FeatureType {
  FEATURE = 'FEATURE',
  IMPROVEMENT = 'IMPROVEMENT',
  FIX = 'FIX',
  BREAKING_CHANGE = 'BREAKING_CHANGE',
}

export interface ReleaseFeature {
  moduleName?: string;
  title: string;
  description: string;
  type: FeatureType | string;
}

export interface AppRelease {
  id?: string;
  version?: string;
  type?: ReleaseType | string;
  releasedAt?: string | Date;
  status?: number;
  application?: {
    id: 'ea4658be-f248-4b7d-bace-d36ff9cb40ec';
    name: 'qihotels';
    description: 'aplciacion qihotels';
  };
  createdAt?: string | Date;
  features?: ReleaseFeature[];
}
